/// <amd-module name="VSSUI/Sizer" />
export { Sized, Sizer } from "./Components/Sizer/Sizer";
export { ISizerProps, Orientation, Position } from "./Components/Sizer/Sizer.Props";
